<template>
    <ul :class="className">
        <li
                v-for="(item, index) in list"
                :class="[item.extraClass, {'active': active === index}]"
                :key="index"
        >
            <router-link :to="item.url" :class="[item.linkClass]">
                {{ item.text }}
            </router-link>
            <span class="sub-toggle" v-if="item.subMenu" @click="openSubItem(index)">
                <i class="fa fa-chevron-down"></i>
            </span>
            <slide-up-down v-model="isOpen" :duration="1000">
                <ul v-if="item.subMenu" :class="item.subClass">
                    <li v-for="(val, idx) in item.subMenu" :key="idx" :class="{'active': subActive === idx}">
                        <router-link :to="val.url" :class="[val.linkClass]">
                            {{ val.text }}
                        </router-link>
                    </li>
                </ul>
            </slide-up-down>
        </li>
    </ul>
</template>

<script>
    import SlideUpDown from "vue3-slide-up-down";

    export default {
        name: 'module-main-menu',
        components: {SlideUpDown},
        props: {
            list: {
                type: Array,
                default: () => []
            },
            className: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                isOpen: false,
                active: null,
                subActive: null
            }
        },
        methods: {
            openSubItem(index) {
                if (index === this.active) {
                    this.active = null;
                } else {
                    this.active = index;
                }
                this.isOpen = !this.isOpen;
            },
            openSubChild(index) {
                if (index === this.subActive) {
                    this.subActive = null;
                } else {
                    this.subActive = index;
                }
            }
        }
    }
</script>
